module.exports = "<p>Possible images for meme</p>"